import { render, staticRenderFns } from "./MaskLP.vue?vue&type=template&id=a422ba36&scoped=true&"
import script from "./MaskLP.vue?vue&type=script&lang=js&"
export * from "./MaskLP.vue?vue&type=script&lang=js&"
import style0 from "./MaskLP.vue?vue&type=style&index=0&id=a422ba36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a422ba36",
  null
  
)

export default component.exports